import React from 'react';
import './Footer.css';
import { Facebook, Twitter, Instagram } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact</h3>
          <p>Oxford Convent English Medium School, Khajuri</p>
          <p>Aland, Kalaburgi, Karnataka - 585314</p>
          <p>Email: <span>oxfordconvent2013@gmail.com</span></p>
          <p>Phone: +91 9008680776</p>
          <p>Mobile: +91 7829391555</p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li>
              <RouterLink to="/about-school" className="footer-link">About School</RouterLink>
            </li>
            <li>
              <RouterLink to="/why-this-school" className="footer-link">Why This School</RouterLink>
            </li>
            <li>
              <RouterLink to="/contact-us" className="footer-link">Contact Us</RouterLink>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <p>Stay connected with us on social media.</p>
          <div className="footer-socials">
            <Facebook />
            <Twitter />
            <Instagram />
          </div>
        </div>
      </div>

      <hr className="footer-divider" />

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>© 2025 Oxford Convent English Medium School Khajuri. All rights reserved.</p>
        <p className="footer-powered-by">
          <a href="https://terradigitalizedynamics.com/" target="_blank" rel="noopener noreferrer">
            Powered by TerraDigitalize Dynamics
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
